import { configureStore } from '@reduxjs/toolkit';
import cronReducer from './slices/cronSlice';
import authReducer from './slices/loginSlice';

export const store = configureStore({
  reducer: {
    cron: cronReducer,
    auth: authReducer,
  },
});
